export default "__VITE_ASSET__aBrMeGKz__"